import PhotoPreview from './PhotoPreview';
export default PhotoPreview;
